export enum ServiceCode {
    DermaOth = 'DermaOth',
    GTO = 'GTO',
    Optometry = 'Optometry',
    OSAS = 'OSAS',
    OSASC1 = 'OSASC1',
    OSASC2 = 'OSASC2',
    OSASO = 'OSASO',
    OSASQ = 'OSASQ',
    OSASV = 'OSASV',
    OSASVC = 'OSASVC',
    OSASVO = 'OSASVO',
    TOC = 'TOC',
    TOO = 'TOO',
}
